import TemplatesPage from "@/pages/templates";
import type { RouteConfig } from "./types";

export const templatesRoutes: RouteConfig[] = [
	{
		path: "/templates",
		element: <TemplatesPage />,
	},
	{
		path: "/templates/:AssetIdParam",
		element: <TemplatesPage />,
	},
];
